import qs from 'qs'
import moment from 'moment'
import uniq from 'lodash/uniq'
import keyBy from 'lodash/keyBy'
import omit from 'lodash/omit'
import debounce from 'lodash/debounce'
import React, { Component, PropTypes } from 'react'
import { browserHistory } from 'react-router'
import { CardTitle } from 'material-ui/Card'
import get from 'lodash/get'
import set from 'lodash/set'
import api from '../../../api'
import Filters from '../filters'
import Actions from './actions'
import Table from './table'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

class List extends Component<any, any> {
  constructor (props) {
    super(props)

    const defaults = props.defaults || {}
    const query = qs.parse((this.props.locationSearch || '?').substring(1))

    this.state = {
      query: Object.assign({
        offset: 0,
        limit: 10,
        order: '',
        filters: props.fixedFilters || {}
      }, defaults, query),
      filters: (props.filters || []).map(filter => (
        Object.assign({
          enabled: !!(query.filters && query.filters[filter.prop])
        }, filter)
      )),
      relationships: {},
      autocompleteText: {},
      autocompleteResults: {},
      filterMenuOpen: false,
      collection: [],
      actionPathname: props.actionPathname || props.locationPathname,
      isExporting: false,
      sortFunction: props.sortFunction
    }
// @ts-ignore
    this.debouncedAutocompleteUpdate = debounce(this.performAutocompleteUpdate.bind(this), 500)
  }

  componentWillMount () {
    // @ts-ignore
    this.getList()
    this.getAutocompleteText()
  }

  getList (changes) {
    const query = Object.assign({}, this.state.query, changes)

    api
      .get(this.props.apiIndexPath || this.props.apiPath, { body: query })
      .then(res => {
        const totalCount = res.headers.get('x-total-count')

        if (totalCount !== null) {
          this.setState({ totalCount: parseInt(totalCount, 10) })
        } else {
          this.setState({ totalCount: null })
        }

        res.json().then(collection => {
          this.setState({ collection })
          return collection
        }).then(collection => {
          this.getRelations(collection)
        })
      })
  }

  getAutocompleteText () {
    this.state.filters.forEach(filter => {
      if (filter.type !== 'autocomplete' || !get(this.state.query, filter.prop)) {
        return
      }

      const body = {
        'filters[ids]': get(this.state.query, filter.prop)
      }

      api
        .get(filter.references, { body })
        .then(res => res.json())
        .then(collection => {
          if (!collection[0]) {
            return
          }

          this.setState({
            autocompleteText: Object.assign(this.state.autocompleteText, {
              [filter.references]: collection[0][filter.referenceProp]
            })
          })
        })
    })
  }

  getRelations (collection) {
    this.props.columns
      .filter(column => column.references)
      .map(column => {
        const ids = collection
          .filter(item => item[column.prop])
          .map(item => item[column.prop])

        if (ids.length === 0) {
          return
        }

        const body = {
          'filters[ids]': uniq(ids),
          with_deleted: true
        }
        api
          .get(column.references, { body })
          .then(res => res.json())
          .then(collection => {
            this.setState({
              relationships: {
                ...this.state.relationships,
                [column.references]: {
                  ...this.state.relationships[column.references],
                  [column.prop]: keyBy(collection, 'id')
                }
              }
            })
          })
      })
  }

  setQuery (changes) {
    const changedQuery = Object.assign({}, this.state.query, changes)

    const query = qs.stringify(changedQuery)

    browserHistory.push(`${this.props.locationPathname}?${query}`)

    this.setState({
      query: changedQuery
    })

    this.getList(changes)
  }

  unsetQueryParameters (parameters = []) {
    const newQuery = Object.assign({}, this.state.query)

    parameters.forEach(param => {
      set(newQuery, param, undefined)
    })

    this.setQuery(newQuery)
  }

  handleLimitChange (e, i, val) {
    this.setQuery({
      limit: val
    })
  }

  handlePrevPage () {
    this.setQuery({
      offset: Math.max(0, parseInt(this.state.query.offset, 10) - parseInt(this.state.query.limit, 10))
    })
  }

  handleNextPage () {
    this.setQuery({
      offset: parseInt(this.state.query.offset, 10) + parseInt(this.state.query.limit, 10)
    })
  }

  handleCreate () {
    browserHistory.push(`${this.state.actionPathname}/create`)
  }

  handleMenuItemTouchTap (event, obj) {
    if (obj.props.value) {
      browserHistory.push(obj.props.value)
    }
  }

  handleFilterMenuOpen (e) {
    e.preventDefault()

    this.setState({
      filterMenuOpen: true,
      filterAnchorEl: e.currentTarget
    })
  }

  handleFilterMenuClose () {
    this.setState({
      filterMenuOpen: false
    })
  }

  handleFilterTap (index) {
    const filters = this.state.filters.slice()
    const filter = filters[index]
    filter.enabled = !filter.enabled

    if (filter.enabled) {
      if (filter.type === 'bool') {
        const newQuery = Object.assign({}, this.state.query)
        set(newQuery, filter.prop, filter.value)
        this.setQuery(newQuery)
      }
    } else {
      this.unsetQueryParameters([filter.prop])
    }

    this.setState({
      filters
    })
  }

  handleFilterTextChange (filter, e) {
    const newQuery = Object.assign({}, this.state.query, { offset: 0 })

    set(newQuery, filter.prop, e.target.value || undefined)

    this.setQuery(newQuery)
  }

  handleFilterSelectChange (i, filter, e, key, val) {
    const newQuery = Object.assign({}, this.state.query, { offset: 0 })

    if (val === null) {
      set(newQuery, filter.prop, undefined)
    } else {
      set(newQuery, filter.prop, val)
    }

    this.setQuery(newQuery)
  }

  handleSortColumn (column, e) {
    e && e.preventDefault()

    const currentColumn = this.state.query.order[0].column
    const currentDirection = this.state.query.order[0].direction || 'asc'

    if (currentColumn === column.prop) {
      const newDirection = currentDirection === 'asc' ? 'desc' : 'asc'
      this.setQuery({
        order: [{ column: currentColumn, direction: newDirection }]
      })
    } else {
      this.setQuery({
        order: [{ column: column.prop, direction: currentDirection }]
      })
    }
  }

  handleAutocompleteUpdateInput (filter, searchText) {
    if (searchText === '' && get(this.state.query, filter.prop)) {
      const newQuery = Object.assign({}, this.state.query, { offset: 0 })
      this.setQuery(newQuery)
      this.unsetQueryParameters([filter.prop])
    }

    // Debounce the API call
// @ts-ignore
    this.debouncedAutocompleteUpdate(filter, searchText)
  }

  performAutocompleteUpdate (filter, searchText) {
    const apiQuery = {
      filters: {
        [`${filter.referenceProp}_ilike`]: searchText
      },
      limit: 5
    }

    const { query = {} } = filter

    if (query.filters) {
      apiQuery.filters = Object.assign({ }, apiQuery.filters, query.filters)
    }

    if (query.order) {
// @ts-ignore
      apiQuery.order = query.order
    }

    if (filter.customFilters) {
      Object.keys(filter.customFilters).map(filterKey => {
        apiQuery[`filters[${filterKey}]`] = filter.customFilters[filterKey]
      })
    }

    api
      .get(filter.references, { body: apiQuery })
      .then(res => res.json())
      .then(collection => {
        this.setState({
          autocompleteResults: Object.assign({}, this.state.autocompleteResults, {
            [filter.references]: filter.dataHydrator ? filter.dataHydrator(collection) : collection
          })
        })
      })
  }

  handleAutocompleteSelection (filter, chosenRequest, selectedIndex) {
    if (selectedIndex === -1) {
      // enter pressed in the autocomplete field
      return
    }

    const idProp = filter.idProp || 'id'
    const query = { ...this.state.query }

    set(query, filter.prop, chosenRequest[idProp])

    this.setQuery({
      offset: 0,
      filters: query.filters
    })
  }

  handleDatePickerUpdate (filter, e, date) {
    const query = { ...this.state.query }

    set(query, filter.prop, moment(date).format('YYYY-MM-DD'))

    this.setQuery({
      offset: 0,
      filters: query.filters
    })
  }

  handleFilterMultipleSelectChange (filter, e, i, values) {
    const query = { ...this.state.query }
    set(query, filter.prop, values)

    this.setQuery({
      offset: 0,
      filters: query.filters
    })
  }

  handleFilterMultipleSelectChipDelete (filter, values, valueToBeDeleted) {
    const query = { ...this.state.query }
    values.splice(values.indexOf(valueToBeDeleted), 1)
    set(query, filter.prop, values)

    this.setQuery({
      offset: 0,
      filters: query.filters
    })
  }

  handleExport (option) {
    this.setState({ isExporting: true })
    const { query } = this.state
    const apiPath = this.props.apiIndexPath || this.props.apiPath
    const path = `${apiPath}/${option.exportPath}`

    api.get(path, { body: omit(query, 'limit') })
      .then(res => res.json())
      .then(body => {
        this.setState({
          download: body,
          isExporting: false
        })
      })
  }

  closeExportDialog () {
    this.setState({ download: null })
  }

  render () {
    const { withExport, customActions, createNewLabel } = this.props

    let exportOptions
    if (withExport === true) {
      exportOptions = [{ label: 'Export', exportPath: 'export' }]
    } else if (Array.isArray(withExport) && withExport.length) {
      exportOptions = withExport
    }

    return (
      <div>
        <Actions
          filters={this.state.filters}
          filterMenuOpen={this.state.filterMenuOpen}
          filterAnchorEl={this.state.filterAnchorEl}
          handleFilterMenuOpen={this.handleFilterMenuOpen.bind(this)}
          handleFilterMenuClose={this.handleFilterMenuClose.bind(this)}
          handleFilterTap={this.handleFilterTap.bind(this)}
          handleCreate={this.handleCreate.bind(this)}
          createNewLabel={createNewLabel}
          hideCreate={this.props.hideCreate}
          exportOptions={exportOptions}
          customActions={customActions}
          isExporting={this.state.isExporting}
          handleExport={this.handleExport.bind(this)}
        />
        <CardTitle title={this.props.title} style={{ paddingLeft: 0 }} />
        <Filters
          values={this.state.query}
          filters={this.state.filters}
          handleFilterTextChange={this.handleFilterTextChange.bind(this)}
          autocompleteText={this.state.autocompleteText}
          autocompleteResults={this.state.autocompleteResults}
          handleAutocompleteSelection={this.handleAutocompleteSelection.bind(this)}
          handleAutocompleteUpdateInput={this.handleAutocompleteUpdateInput.bind(this)}
          handleDatePickerUpdate={this.handleDatePickerUpdate.bind(this)}
          handleFilterMultipleSelectChange={this.handleFilterMultipleSelectChange.bind(this)}
          handleFilterMultipleSelectChipDelete={this.handleFilterMultipleSelectChipDelete.bind(this)}
          handleFilterSelectChange={this.handleFilterSelectChange.bind(this)}
        />
        <Table
          query={this.state.query}
          hidePagination={this.props.hidePagination}
          paginationTotal={this.state.totalCount}
          columns={this.props.columns}
          collection={this.state.collection}
          relationships={this.state.relationships}
          handleSortColumn={this.handleSortColumn.bind(this)}
          handleMenuItemTouchTap={this.handleMenuItemTouchTap.bind(this)}
          handleLimitChange={this.handleLimitChange.bind(this)}
          handlePrevPage={this.handlePrevPage.bind(this)}
          handleNextPage={this.handleNextPage.bind(this)}
          hideEdit={this.props.hideEdit}
          buildMenuItems={this.props.buildMenuItems}
          sortFunction={this.state.sortFunction}
        />

        {
          this.state.download &&
            <Dialog
              title='Download Exported File'
              modal={false}
              open
              actions={[
                <FlatButton
                  label='Close'
                  primary
                  onClick={this.closeExportDialog.bind(this)}
                />
              ]}
              onRequestClose={this.closeExportDialog.bind(this)}
            >
              <a href={this.state.download.url}>
                {this.state.download.filename}
              </a>
            </Dialog>
        }
      </div>
    )
  }
}

// @ts-ignore
List.propTypes = {
  title: PropTypes.string.isRequired,
  createNewLabel: PropTypes.string,
  apiPath: PropTypes.string.isRequired,
  apiIndexPath: PropTypes.string,
  locationPathname: PropTypes.string.isRequired,
  actionPathname: PropTypes.string,
  customActions: PropTypes.array,
  locationSearch: PropTypes.string.isRequired,
  hideEdit: PropTypes.bool,
  hideCreate: PropTypes.bool,
  hidePagination: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  buildMenuItems: PropTypes.func.isRequired,
  withExport: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.arrayOf(PropTypes.object)
  ])
}

// @ts-ignore
List.defaultProps = {
  withExport: false
}

export default List
